/** Settings, Users tab: the team list from `staff.list`; edits through `staff.update`. */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { UsersTable } from '../../components/settings/users-table';
import { useActor } from '../../lib/auth';
import { staffQuery } from '../../lib/queries';
import { describeRpcError, rpc } from '../../lib/rpc';

export const Route = createFileRoute('/settings/users')({
  component: Users,
});

function Users() {
  const qc = useQueryClient();
  const actor = useActor();
  const q = useQuery(staffQuery());
  if (q.error) return <p className="text-body text-alert">{describeRpcError(q.error)}</p>;
  if (!q.data) return <p className="text-body text-ink-3">Loading the team</p>;
  const refresh = () => qc.invalidateQueries({ queryKey: staffQuery().queryKey });
  return (
    <UsersTable
      data={q.data}
      viewerEmail={actor?.email ?? ''}
      onUpdate={async (email, edit) => {
        try {
          await rpc.staff.update({ email, ...edit });
        } catch (err) {
          throw new Error(describeRpcError(err), { cause: err });
        } finally {
          await refresh();
        }
      }}
      onAddDepartment={async (name) => {
        await rpc.staff.addDepartment({ name });
        await refresh();
      }}
    />
  );
}
